<div class="userIcon" [matMenuTriggerFor]="menu" [class.authenticated]="currentUser?.authenticated">
  <mat-icon class="dp32">{{ iconName }}</mat-icon>
  <span class="userName">{{ currentUser?.firstName ? currentUser.firstName : 'Guest' }}</span>
</div>
<mat-menu #menu>
  <button *ngFor="let item of getActiveMenu()" (click)="item.click()" mat-menu-item>{{ item.text }}</button>
</mat-menu>
